import React from "react"
import { useMaterielModel } from "../materielModel"
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";

export function SearchForm() {
    const {
        searchParam,
        upDataSearchParam,
        resetSearchParam,
        loadData
    } = useMaterielModel();
    const { appDs } = useGlobalModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "分支编码",
            fieldName: "branch",
            size: "small",
            disabled: false,
            options: appDs
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "物料编码",
            fieldName: "code",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "物料名称",
            fieldName: "name",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "状态",
            fieldName: "enable",
            size: "small",
            disabled: false,
            options: [{ key: "0", label: "关闭", value: "0" }, { key: "1", label: "开启", value: "1" }]
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "厂家编码",
            fieldName: "factoryCode",
            size: "small",
            disabled: false,
        }
    ]
    return (
        <YhPageHeader
            title="物料管理列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={upDataSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    )
}